<div #chart class="area-line-chart-container" style="width: 100%; height: calc(100% - 27px); position: relative;"></div>

<div class="list-button">
  <ul class="graph-point">
    @for (item of legend(); track item) {
      <li>
        <div class="legend-color" [style.backgroundColor]="item?.color || 'gray'"></div>{{ item?.legend || '' }}
      </li>
    }
  </ul>
</div>